import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleTonnageMasterDelete } from "../../../Api/api";

export const removeTonnageMasterAsync = createAsyncThunk(
   "tonnageMaster/delete",
   async ({ id, done, err }) => {
      try {
         const response = await handleTonnageMasterDelete(id);
         done && done();
         return response.data;
      } catch (error) {
         const errorMessage =
            error?.response?.data?.message || "Failed to delete Tonnage";

         err && err(errorMessage);
         throw error?.response?.data || errorMessage;
      }
   }
);




